// extracted by css-extract-rspack-plugin
export default {"link":"tQUad"};